<div mat-dialog-content>
    <p>{{ 'aumico_templates_form_create_sub_fli_or_of_that_item' | i18next }}</p>
    <div *ngIf="form" [formGroup]="form" class="form">
        <div>
            <mat-checkbox color="primary" class="of-that-item-checkbox" formControlName="isOfThatItem">
                <span class="aum-typo-paragraph">
                    {{ 'aumico_templates_group_account_mapping_add_more_items_of_that_item_checkbox' | i18next }}
                </span>
            </mat-checkbox>
        </div>

        <mat-form-field>
            <mat-label>{{ 'aumico_templates_name' | i18next }}</mat-label>
            <input matInput formControlName="name" />
            <mat-error *ngIf="form.get('name').hasError('required')">
                {{ 'aumico_core_form_mandatory_error' | i18next }}
            </mat-error>
        </mat-form-field>

        <div class="d-flex">
            <mat-form-field>
                <mat-label>{{ 'aumico_templates_description' | i18next }} </mat-label>
                <input matInput formControlName="caption" />
                <mat-error *ngIf="form.get('caption').hasError('required')">
                    {{ 'aumico_core_form_mandatory_error' | i18next }}
                </mat-error>
            </mat-form-field>
            <aum-select
                [aumFormControl]="form.get('language')"
                [options]="languages"
                (selectionChange)="onLanguageSelectionChange()"
            >
                <aum-form-field-label> {{ 'aumico_admin_form_language' | i18next }} </aum-form-field-label>
            </aum-select>
        </div>

        <div class="action-buttons">
            <aumico-button [disabled]="form.invalid" (click)="save()"
                >{{ 'aumico_templates_save' | i18next }}
            </aumico-button>
            <aumico-button (click)="closeDialog()">{{ 'aumico_templates_cancel' | i18next }}</aumico-button>
        </div>
    </div>
</div>
